module.exports = __webpack_public_path__ + "tn.e45d72abdeace3664fa5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/tn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/tn.svg
// module chunks = styles